<footer class="container">
  <div class="row py-4">
    <div class="col-md-8"><img src="assets/img/logo.jpg">
      <p class="mb-0 text-justify"> OMNI is the world's first SaaS platform that democratizes automation. Whether it is
        building your digital talent pool by upskilling your employees on AI &amp; RPA technologies or unlocking better
        ROI realization on your current automation investments, OMNI's got you covered. OMNI provides hands-on training
        to your employees, enabling them to contribute to your automation journey, without risks, and with confidence.
      </p>
    </div>

    <div class="col-md-4">
      <h4 class="h4">Subscribe our Newsletter</h4>
      <div class="d-flex align-items-center">
        <input class="search form-control form-control-lg mr-3 ng-untouched ng-pristine ng-valid" [(ngModel)]="email"
          name="subscribetomail" id="email" placeholder="Enter Email" type="text">
        <a class="bg-button btn btn-primary flex-grow-1 bd-highlight" href="javascript:;"
          (click)="subscribeToNewsletter()">Subscribe</a>
      </div>

      <div class="mt-4 align-items-center">
        <span>Follow us: </span>
        <a class="follow-us" href="https://www.linkedin.com/company/omnibotlearn/"
          target="_blank"><i class="fab fa-linkedin mr-2 ml-2"></i></a>
        <a href="https://www.facebook.com/OMNIUpskilling" class="follow-us" target="_blank"><i
            class="fab fa-facebook mr-2"></i></a>
        <a href="https://www.youtube.com/channel/UCbDdtrOClWt1eUe2WTEKCIQ" class="follow-us"
          target="_blank"><i class="fab fa-youtube mr-2"></i></a>
        <a href="https://www.instagram.com/omni_upskilling/" target="_blank" class="follow-us">
          <i class="fab fa-instagram"></i>
        </a>
      </div>
    </div>
  </div>

  <hr>

  <div class="row">
    <div class="col-md-12 text-center">
      <p>© {{currentDate | date:'yyyy'}} <a href="https://www.airodigitallabs.com/" target="_blank">AiRo Digital
          Labs.</a> All right reserved.&nbsp;&nbsp;&nbsp;
        <a target="_blank" [href]="showTCAndRefundPolicy('tnc')">Terms and Conditions</a>&nbsp;&nbsp;&nbsp;
        <a target="_blank" [href]="showTCAndRefundPolicy('refund-policy')">Refund Policy</a>
      </p>
    </div>
  </div>
</footer>

<div class="modal fade" id="subscribed-modal" tabindex="-1" role="dialog" aria-labelledby="subscribed-modal"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h5 class="modal-title h3">Thank You for subscribing</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary border-button" data-dismiss="modal">Ok</button>
      </div>
    </div>
  </div>
</div>